import { createBadgeColorMap } from '~/utils/common';

import {
  RECEIVE_REPORT_STATUS,
  RECEIVE_REPORT_STATUS_BADGE_COLOR,
  RECEIVE_REQUEST_STATUS,
  RECEIVE_REQUEST_STATUS_BADGE_COLOR,
  RECEIVE_STATUS_DETAIL_STATUS,
  RECEIVE_STATUS_DETAIL_STATUS_BADGE_COLOR,
  RECEIVE_STATUS_STATUS,
  RECEIVE_STATUS_STATUS_BADGE_COLOR,
} from '~/constants';

export const RECEIVE_REQUEST_STATUS_COLOR_MAP = createBadgeColorMap(
  RECEIVE_REQUEST_STATUS,
  RECEIVE_REQUEST_STATUS_BADGE_COLOR
);

export const RECEIVE_STATUS_STATUS_COLOR_MAP = createBadgeColorMap(
  RECEIVE_STATUS_STATUS,
  RECEIVE_STATUS_STATUS_BADGE_COLOR
);

export const RECEIVE_STATUS_DETAIL_STATUS_COLOR_MAP = createBadgeColorMap(
  RECEIVE_STATUS_DETAIL_STATUS,
  RECEIVE_STATUS_DETAIL_STATUS_BADGE_COLOR
);

export const RECEIVE_REPORT_STATUS_COLOR_MAP = createBadgeColorMap(
  {
    REGISTERED: RECEIVE_REPORT_STATUS.REGISTERED.text,
    COMPLETED: RECEIVE_REPORT_STATUS.COMPLETED.text,
    CANCELED: RECEIVE_REPORT_STATUS.CANCELED.text,
    NONE: RECEIVE_REPORT_STATUS.NONE.text,
  },
  RECEIVE_REPORT_STATUS_BADGE_COLOR
);
